import { ref, watch, onMounted } from 'vue';

type Theme = 'light' | 'dark';

const STORAGE_KEY = 'nxt-admin-theme';

// État global partagé entre tous les composants qui appellent useTheme()
const theme = ref<Theme>('light');

function applyTheme(t: Theme) {
  document.documentElement.setAttribute('data-theme', t);
}

function initTheme() {
  const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
  // Light par défaut — on n'applique le dark que si l'utilisateur l'a choisi explicitement
  theme.value = stored === 'dark' ? 'dark' : 'light';
  applyTheme(theme.value);
}

export function useTheme() {
  onMounted(() => {
    if (!document.documentElement.hasAttribute('data-theme')) {
      initTheme();
    }
  });

  watch(theme, (t) => {
    applyTheme(t);
    localStorage.setItem(STORAGE_KEY, t);
  });

  function toggle() {
    theme.value = theme.value === 'light' ? 'dark' : 'light';
  }

  function setTheme(t: Theme) {
    theme.value = t;
  }

  const isDark = ref(false);
  watch(
    theme,
    (t) => {
      isDark.value = t === 'dark';
    },
    { immediate: true },
  );

  return { theme, isDark, toggle, setTheme };
}

// Initialisation immédiate pour éviter le flash de thème au chargement
if (typeof window !== 'undefined') {
  initTheme();
}
